import { useLocation } from 'react-router-dom';

const useRedirectUrl = () => {
    const location = useLocation();
    return new URLSearchParams(location.search).get('redirectUrl');
};

export default useRedirectUrl;
